import React, { useMemo, useState, useEffect } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { useNavigate } from 'react-router-dom';
import { Button, Stack } from '@mui/material';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useMediaQuery } from '@mui/material';
import { useDateTime } from '../../pages/ContextDateandTime/DateTimeContext';
const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
});

const Table = ({ type, column, data, onRowClick, row, isLoading }) => {
    const isSmallScreen = useMediaQuery('(max-width: 1366px) and (max-height: 768px)');
    const isMediumScreen = useMediaQuery('(max-width: 1920px) and (max-height: 1080px)');
    const isLargeScreen = useMediaQuery('(min-width: 1920px) and (min-height: 1080px)');
    const navigate = useNavigate();
    const columns = useMemo(() => column, []);
    const { rowSelection, setRowSelection } = useDateTime();


    const table = useMaterialReactTable({
        columns,
        data,
        enableRowSelection: (row) => {
            return !row.original.deleted_at;
        },
        getRowId: (row) => row?.id,
        onRowSelectionChange: setRowSelection,

        state: { rowSelection, isLoading: isLoading },
        muiFilterTextFieldProps: {
            sx: { m: '0.5rem 0', width: '100%' },
            variant: 'outlined',
        },
        enableFacetedValues: false,
        muiTableBodyRowProps: ({ row }) => ({
            onClick: (event) => {
                onRowClick(row);
            },
            sx: {
                cursor: 'pointer',
                '& .Mui-checked': {
                    fontSize: isSmallScreen ? '8px' : isMediumScreen ? '16px' : '24px', // Font size of the checkbox on selection
                },
                '& .MuiCheckbox-root': {
                    padding: isSmallScreen ? '4px' : '6px', // Adjust padding to reduce the size
                },
                backgroundColor: '#f5f5f5', // Default row background color
                '&:nth-of-type(odd)': {
                    backgroundColor: '#ffffff', // Alternate rows with white
                },
                '&:hover': {
                    backgroundColor: '#e0e0e0', // Hover effect
                    cursor: 'pointer'
                },
            },
        }),
        muiTableContainerProps: {
            sx: {
                maxHeight: '100vh',
                overflowX: 'auto',  // Horizontal scrollbar only for the table
            }
        },
        enablePagination: false,
        enableStickyHeader: true,
        enableTopToolbar: true,
        enableDensityToggle: false,
        enableHiding: false,
        showSkeletons: false,
        enableColumnFilterModes: false,
        enableColumnActions: false,
        enableColumnOrdering: false,
        enableFullScreenToggle: false,
        enableColumnFilters: false,
        enableGlobalFilter: false,
        globalFilter: false,
        initialState: {
            showGlobalFilter: false,
        },
        muiSkeletonProps: {
            animation: 'pulse',
            height: 28,
        },
        muiCircularProgressProps: {
            color: 'secondary',
            thickness: 5,
            size: 55,
        },

    });
const handleExportRows = (rows) => {
    const rowData = rows.map((row) => row.original);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
};

const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
};
return (
    <>
        {type === 'people' && (
            <Stack direction={'row'}>
                <Button
                    disabled={table.getRowModel().rows.length === 0}
                    onClick={() => handleExportRows(table.getRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Page Rows
                </Button>
                <Button
                    disabled={table.getRowModel().rows.length === 0}
                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    onClick={handleExportData}
                    startIcon={<FileDownloadIcon />}
                >
                    Export All Data
                </Button>
            </Stack>
        )}
        <MaterialReactTable table={table} />
    </>
);
};

export default Table;
